import { motion } from 'framer-motion';
import { forwardRef, memo } from 'react';
import { Box, Text, VStack, ListItem, UnorderedList } from '@chakra-ui/react';

import { SwitcherCompactDesign } from './SwitcherCompactDesign';

import { DEFAULT_BORDER } from 'constants/global';

const Switcher = (
  {
    uniqueId,
    labels = null,
    onLabelClick = null,
    activeLabel = null,
    btnSx = null,
    isCompactDesign = false,
    ...props
  },
  ref,
) => (
  <VStack
    ref={ref}
    w={isCompactDesign && 'full'}
    align="start"
    pos="relative"
    bgColor="bg.white"
    border={DEFAULT_BORDER}
    borderColor="bg.black"
    borderRadius={{ mobile: '28px', laptop: '32px' }}
    flexShrink="0"
    p="3px"
    {...props}
  >
    {isCompactDesign ? (
      <SwitcherCompactDesign
        labels={labels}
        activeLabel={activeLabel}
        onLabelClick={onLabelClick}
      />
    ) : (
      <UnorderedList styleType="none" display="flex" gap={{ mobile: '10px', laptop: '20px' }} m="0">
        {labels?.map((label, i) => (
          <ListItem
            key={i}
            pos="relative"
            flexShrink="0"
            cursor="pointer"
            p={{ mobile: '9px 16px', laptop: '17px 24px 14px' }}
            onClick={() => onLabelClick(label)}
            {...btnSx}
          >
            <Text
              textStyle="h2"
              fontSize={{ mobile: '12px', laptop: '18px' }}
              pos="relative"
              zIndex="10"
            >
              {label}
            </Text>

            {label === activeLabel && (
              <Box
                as={motion.div}
                bgColor="bg.accent"
                layoutId={uniqueId}
                h="full"
                pos="absolute"
                borderRadius="full"
                inset="0 0 0 0"
                zIndex="5"
              />
            )}
          </ListItem>
        ))}
      </UnorderedList>
    )}
  </VStack>
);

export const SwitcherComponent = memo(forwardRef(Switcher));
